import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/cinzel';
import '@fontsource-variable/inter';
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/screens.css';
import './styles/effects.css';
import { App } from './App.js';
import { loadMirror } from './assets/mirror.js';
import { registerSW } from 'virtual:pwa-register';
import { initPwa } from './pwa.js';
import { StoreProvider } from './game/context.js';
import { detectLang, loadLang, translate } from './i18n/index.js';
import { httpApi, loginNoticeFrom } from './game/api.js';
import { localPrefsStore } from './game/prefs.js';
import { GameStore } from './game/store.js';

// The server's login callback reports failures as `#/?login=<reason>`: read it once, then clean the address.
const notice = loginNoticeFrom(window.location.hash);
if (notice) history.replaceState(null, '', `${window.location.pathname}#/`);
// Online only (ADR-016): the account comes from the server; actions arrive with T3.8.
const store = new GameStore(httpApi(), localPrefsStore(), () => Date.now(), detectLang(), notice);
store.formatMessage = (key, lang) => translate(lang, key);
void store.load();
loadMirror();
initPwa(registerSW);
const root = document.getElementById('root');
// The UI language is a separate chunk: fetch it before the first paint.
void loadLang(store.getSnapshot().prefs.lang).finally(() => {
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <StoreProvider store={store}>
        <App />
      </StoreProvider>
    </StrictMode>,
  );
});
